//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/building'
import log_mixins from '@/common/mixins/log'
import HouseItem from '@/components/business/house_item'
import Pagination from '@/common/mixins/pagination'
import { mapHouseItem } from '@/common/utils/map_view_data'
import EmptyBox from '@/components/views/empty_box'
import TopFilter from '../vr/_top_filter'
import PageTopFilter from '@/common/mixins/page_top_filter'
import BackToTop from '@/components/views/back_to_top'

import Search from './_search'

const FILTER_KEYS = [
    'decoration',
    'zone_ids',
    'area',
    'total_price',
    'price',
    'layout',
    'metro',
    'status',
    'zone_section_ids'
]

export default {
    mixins: [
        PageTopFilter,
        Pagination,
        log_mixins('航拍看房')
    ],
    computed: {
        show_list_container () {
            return this.items && this.items.length > 0
        }
    },
    components: {
        HouseItem,
        EmptyBox,
        TopFilter,
        BackToTop,
        Search
    },
    data () {
        return {
            tabs_fixed_top: false,
            filter_tabs: ['区域', '价格', '户型', '面积', '装修'],
            decoration: '',
            zone_ids: '',
            area: '',
            total_price: '',
            price: '',
            layout: '',
            metro: '',
            status: '',
            zone_section_ids: '',
            keyword: '',
        }
    },
    created () {
        this.getData()
    },
    methods: {
        checkTopFilterPosition () {
            const selector = '.list-container'
        },
        onSearch (keyword) {
            this.keyword = keyword
            this.refresh()
        },
        changeFilter (filter) {
            Object.keys(filter).forEach((key) => {
                this[key] = filter[key]
            })
            this.refresh()
        },
        refresh () {
            this.page = 1
            this.getData()
            this.checkTopFilterPosition()
        },
        getData () {
            this.loading = true
            const opt = {
                name: this.keyword,
                page: this.page,
                feature: '全景看房'
            }
            FILTER_KEYS.forEach((key) => {
                if (this[key]) {
                    opt[key] = this[key]
                }
            })
            Service.getBuildings(opt).then((data) => {
                this.handleData(data, {
                    handleItem: mapHouseItem
                })
            })
        }
    }
}
